import { Lead } from "@kanda-libs/ks-frontend-services";
import { useSelector } from "react-redux";
import leadSelectors from "store/selectors/lead";

export interface LeadsPipelineHook {
  leadsByStatus: Record<Lead["status"], Lead[]>;
  statuses: Lead["status"][];
}

export default function useLeadsPipeline(): LeadsPipelineHook {
  const leadsByStatus = useSelector(leadSelectors.getLeadsByStatus);
  const statuses = useSelector(leadSelectors.getLeadStatuses);

  return {
    leadsByStatus,
    statuses,
  };
}
